<ng-container *transloco="let t">
  @if (state()) {
    <span class="badge me-2 mb-1" [ngClass]="badgeClass()">{{ t('enum.Activity.State.' + state()) }}</span>
    @if (verbose() && isDraft()) {
      Cette activité n'est pas encore publiée et n'est pas visible publiquement
    }
  }

</ng-container>
